<template lang="pug">
v-dialog(scrollable max-width='400px' v-model='dialog' persistent lazy)
  v-card(class='combo-card')
    v-card-title
      v-toolbar-title Выберите объект
    v-card-text()
      v-layout(wrap)
        v-flex(xs12)
          v-select(
            :items='list'
            label='Обьект из 1с'
            item-value='guid'
            item-text='name',
            v-model='link.guid'
          )
        v-flex(xs9)
          v-text-field(
            v-model='link.importFileName'
            label='Название файла импорта'
          )
        v-flex(xs3)
          v-text-field(
            v-model='link.sections'
            label='Секции(,)'
          )          
        v-flex(xs12)
          s-placement-type-picker(v-model='link.object_type' :selected='apartment')
    v-card-actions
      v-spacer
      v-btn(flat @click='$emit("close")') Отмена
      v-btn(
        flat
        color='primary'
        @click.native='addObjectLink()'
      ) Добавить
</template>

<script>
import http from '@/http'

export default {
  props: ['dialog', 'complexId', 'objectId'],

  data: () => ({
    list: [],
    link: {
      guid: null,
      importFileName: null,
      section: null
    },
    isLoading: false,
    apartment: null
  }),

  created() {},

  mounted() {
    this.getObjectsList()
  },

  methods: {
    async getObjectsList() {
      try {
        this.isLoading = true
        this.list = (
          await http.get(
            `data/1c/objects?complex_id=${this.complexId}&object_id=${this.objectId}`
          )
        ).data
      } catch (e) {
        this.$root.showSnack('Не удалось загрузить список объектов 1С')
      } finally {
        this.isLoading = false
      }
    },

    async addObjectLink() {
      try {
        await http.post(`complexes/objects/${this.objectId}/link`, this.link)
        this.$emit('select')
      } catch (e) {
        this.$root.showSnack('Ошибка добавления объекта')
      }
    }
  },

  watch: {
    dialog() {}
  },

  computed: {}
}
</script>

<style scoped>
.combo-card {
  height: 100%;
}
.combo-card >>> .v-list__tile__sub-title,
.combo-card >>> .v-list__tile__title {
  white-space: unset;
}
</style>
